import {Table} from 'react-bootstrap';
import { formatClinicianName } from '../../utils/clinicianName';
import { useSortableTable, SortableTh } from '../SortableTable';
import { formatDateTime } from '../../utils/dateFormat';

const LOG_SORT_COLUMNS = {
    when: { type: 'date', value: (l) => l?.createdAt },
    detail: { type: 'string', value: (l) => l?.text },
    role: { type: 'string', value: (l) => (l?.doctor_id || l?.hr_id || l?.admin_id || l?.created_by || {}).role },
};

const ViewPatientProfileLogType = ({reportBy, logType, logs}) => {
  const tableSort = useSortableTable(logs, { id: 'logs.ViewPatientProfileLogType', columns: LOG_SORT_COLUMNS, defaultSort: { key: 'when', dir: 'desc' } });
  return (
    <div>
        <Table striped hover bordered>
                <thead align="center">
                    <tr>
                        <th>Viewed Patient</th>
                        <th>Viewed By</th>
                        <SortableTh sortKey="role" sort={tableSort}>Role</SortableTh>
                        <SortableTh sortKey="detail" sort={tableSort}>Log Detail</SortableTh>
                        <SortableTh sortKey="when" sort={tableSort}>Date & Time</SortableTh>
                    </tr> 
                </thead>
                <tbody>
                {tableSort.rows.map((log, index) => (
                <tr key={index}>
                    {reportBy === 'doctor' && logType === 'patient' ? <>
                        <td>{log?.patient_id?.firstname} {log?.patient_id?.lastname}
                            <p style={{color: 'gray'}}>{log?.patient_id?.gender}</p>
                        </td>
                        <td>{formatClinicianName(log?.doctor_id)}</td>
                        <td>{log?.doctor_id?.role}</td>
                        <td>{log?.text}</td>
                        <td>{formatDateTime(log?.createdAt)}</td>
                    </> : <>
                        <td>{log?.patient_id?.firstname} {log?.patient_id?.lastname}
                            <p style={{color: 'gray'}}>{log?.patient_id?.gender}</p>
                        </td>
                        <td>HR. {log?.hr_id?.firstname} {log?.hr_id?.lastname}</td>
                        <td>{log?.hr_id?.role}</td>
                        <td>{log?.text}</td>
                        <td>{formatDateTime(log?.createdAt)}</td>
                    </>}
                </tr>
                ))}
            </tbody>
        </Table>
    </div>
  )
}

export default ViewPatientProfileLogType